import {useState} from "react";
import {
  Button,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ButtonGroup,
  makeStyles,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { eliminarDestinoPaqueteAction } from "../../../ducks/paqueteDuck";
import Swal from "sweetalert2";
import { ToastMessage } from "../../../global/ToastMessage";
import { DialogMessage } from "../../../global/DialogMessage";
import BackDrop from "../../../global/BackDrop";
const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  container: {
    maxHeight: 250,
  },
})
const TablaRegistro = (props) => {
  const { rows = [], idPaquete = 0} = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const [isLoad, setIsLoad] = useState(false);
  const onDelete = (destino) =>{
    DialogMessage.fire({
      title: '¿Estas seguro?',
      text: "¡No podrás revertir esto!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Eliminarlo',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) =>{
      if (result.isConfirmed) {
        setIsLoad(true);
        dispatch(eliminarDestinoPaqueteAction(idPaquete, destino.IdCiudad)).then(Response =>{
          setIsLoad(false);
          ToastMessage.fire(
            '¡Elimminado!',
            'El destino ha sido eliminado.',
            'success'
          )
        })
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        ToastMessage.fire(
          'Cancelado',
          'No se ha realizado ningun cambio',
          'info'
        )
      }
    })
  }
  return (
    <div>
    <TableContainer component={Paper} className={classes.container}>
      <Table size="small" stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell align="left">Destino</TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index + 1}>
              <TableCell align="left">{`${row.Pais.Nombre} - ${row.Nombre}`}</TableCell>
              <TableCell align="center">
                <ButtonGroup
                  color="primary"
                  size="small"
                  aria-label="small outlined  button group"
                >
                  <Button onClick={() =>onDelete(row)}>Eliminar</Button>
                </ButtonGroup>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <BackDrop open={isLoad}/>
    </div>
  );
};
export default TablaRegistro;
